import { showPrivacyPreferences } from "../../../../utils/cmp/library";
import LinkWrap from "../../../LinkWrap/component";
import { CONSENT_MODAL_BUTTON_TYPE } from "../../../../utils/cmp/constants";
import "./styles/themes/_default.scss";

function ConsentModalButton({ item, isExternal }) {
    if (isExternal) {
        return (
            <LinkWrap
                className="privacyPreferences"
                url={item.link}
                external={true}
                target="_blank"
                data-testid="consentModalLink"
            >
                {item.title}
            </LinkWrap>
        );
    }

    return (
        <button
            type="button"
            className="privacyPreferences"
            onClick={showPrivacyPreferences}
            data-testid={CONSENT_MODAL_BUTTON_TYPE}
        >
            {item.title}
        </button>
    );
}

export default ConsentModalButton;
